/* unplugin-vue-components disabled */import script from "./IncomeClassification.vue?vue&type=script&setup=true&name=Medal&lang=js"
export * from "./IncomeClassification.vue?vue&type=script&setup=true&name=Medal&lang=js"

import "./IncomeClassification.vue?vue&type=style&index=0&id=71f3e86d&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f3e86d"]])

export default __exports__